export default __webpack_public_path__ + "881198429a6daad9bcb5eeaab29f1dca.png";